// 自研 Go IM 后端专用 axios 实例（与旧 requestCustom 完全隔离）。
import axios from 'axios'

function resolveGoBaseUrl() {
    if (process.env.VUE_APP_GO_BASE_URL) {
        return process.env.VUE_APP_GO_BASE_URL.replace(/\/$/, '')
    }
    if (typeof window === 'undefined' || !window.location) {
        return 'http://127.0.0.1:10010'
    }
    const { protocol, hostname, origin } = window.location
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://127.0.0.1:10010'
    }
    if (/^10\./.test(hostname) || /^192\.168\./.test(hostname) || /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)) {
        return `${protocol}//${hostname}:10010`
    }
    return origin
}

export const GO_BASE_URL = resolveGoBaseUrl()

const service = axios.create({
    baseURL: GO_BASE_URL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json; charset=UTF-8' }
})

// 复用客服端登录态 customToken（Go 后端共享现网 Redis/secret，可验证）
service.interceptors.request.use(
    (config) => {
        let token = window.localStorage.getItem('customToken')
        if (token && token !== 'undefined') {
            try {
                token = JSON.parse(token)
            } catch (e) {
                /* 已是裸字符串 */
            }
        } else {
            token = ''
        }
        // 只发 Authorization（Go CORS 已允许）；不要发 Token 头，否则触发 CORS 预检被拦
        config.headers.Authorization = token ? `Bearer ${token}` : ''
        return config
    },
    (error) => Promise.reject(error)
)

service.interceptors.response.use(
    (response) => {
        const res = response.data
        if (res && res.code >= 400) {
            return Promise.reject(res)
        }
        return res
    },
    (error) => Promise.reject(error)
)

export default service
